import type { ConfigurationValidationError } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import type { ReactElement } from 'react'

import type { ValidationErrorWithLocation } from '../../uiModels/errors/types'

export type ValidStackableRatios = 1 | 1.5 | 2 | 3 | 4 | 5

export type StackableType<D> = {
  value: D
  columns: number
  key: (index?: number) => string
  ratios: readonly ValidStackableRatios[]
  isGrouped?: boolean
  isEmpty?: boolean
  errors: ValidationErrorWithLocation<ConfigurationValidationError>[]
  isActive?: boolean
  shouldShowOnOverflow?: boolean
  isInherited?: boolean
}

export const isStackableType = <D extends Record<string, unknown>>(
  value: Record<string, unknown>,
): value is StackableType<D> =>
  'value' in value &&
  'columns' in value &&
  'ratios' in value &&
  'key' in value &&
  typeof value['key'] === 'function' &&
  Array.isArray(value['ratios'])

export type ChildActionQuestion = string
type ChildActionTestResponse = true | ChildActionQuestion

export const isChildActionQuestion = (
  response: Optional<ChildActionTestResponse>,
): response is ChildActionQuestion => !!response && typeof response === 'string'

type NodeProps = {
  title?: string
  onClick: (evt: MouseEvent) => void
}

export type ChildAction<D> = {
  actionId: string
  title?: string
  action?: (data: StackableType<D>) => void | Promise<void>
  test?: (data: StackableType<D>) => ChildActionTestResponse
  node:
    | Optional<ReactElement<NodeProps>>
    | ((data: StackableType<D>) => Optional<ReactElement<NodeProps>>)
}

export type RowActions<D> = ChildAction<D>[]
